<script>
/**
 * Component: Packages: Option
 *
 * @author PH
 */
export default {
  props: ["id", "name", "title", "type", "description", "settings"],

  computed: {
    /**
     * Value
     *
     * Function manages the state of value field. It connects
     * with VueX to get and set the correct values.
     *
     * @author PH
     * @return mixed
     */
    value: {
      get() {
        return this.$store.getters.getFieldValue(this.id, "packages");
      },
      set(value) {
        this.$store.commit("updateInput", {
          id: this.id,
          section: "packages",
          values: {
            value: value
          }
        });
      }
    },

    /**
     * Price
     *
     * Function returns the price based on the properties.
     * If the price is not number or 0, the system returns
     * other information.
     *
     * @author PH
     * @return string
     */
    price: function() {
      if (
        !this.settings.price ||
        0 >= this.settings.price ||
        "number" !== typeof this.settings.price
      ) {
        return this.settings.price;
      }

      if (this.settings.currency && this.settings.price) {
        return this.settings.currency + this.settings.price.toFixed(2);
      }
    },

    /**
     * Function returns the badge based on option setting.
     *
     * @author PH
     * @return string|null
     */
    badge: function() {
      if (this.settings.badge) {
        return this.settings.badge;
      }
    },

    /**
     * Function returns the asterisk visibility based on option setting.
     *
     * @author PH
     * @return string|null
     */
    asterisk: function() {
      if (this.settings.asterisk) {
        return this.settings.asterisk;
      }
    },

    /**
     * Functions creates the classes object for this input.
     *
     * @author PH
     * @return Object
     */
    classes() {
      const classes = {};

      classes["signup-packages-option--" + this.settings.size] = true;
      classes["signup-packages-option--fullwidth"] = this.settings.fullwidth;

      if (this.settings.image) {
        classes["signup-packages-option--image"] = true;
      }

      return classes;
    },

    isMultiple() {
      return this.settings.multiple !== false;
    }
  },

  methods: {
    appendChange() {
      const next = !this.value;

      if (!this.isMultiple && next) {
        this.clearSiblings();
      }

      this.value = next;
    },

    clearSiblings() {
      const group = this.$store.getters.getFieldData(this.id, "group", "packages");
      const siblings = this.$store.getters.getFieldsBy("group", group, "packages");

      siblings.forEach(field => {
        if (field.id !== this.id && field.value) {
          this.$store.commit("updateInput", {
            id: field.id,
            section: "packages",
            values: {
              value: false
            }
          });
        }
      });
    }
  }
};
</script>

<template>
  <div class="signup-packages-option" :class="classes">
    <button
      type="button"
      :class="{ active: value === true }"
      @click="appendChange()"
    >
      <div>
        <div class="signup-packages-option__header">
          <span class="signup-packages-option__title" v-if="title">{{
            title
          }}</span>
          <span
            class="signup-packages-option__price"
            v-if="0 !== price && 'large' === settings.size"
          >
            {{ price }}
            <span class="signup-packages-option__asterisk" v-if="asterisk"
              >*</span
            >
          </span>
          <span class="signup-packages-option__badge" v-if="badge">{{
            badge
          }}</span>
        </div>

        <div
          class="signup-packages-option__description"
          v-if="description"
          v-html="description"
        ></div>

        <div class="signup-packages-option__image" v-if="settings.image">
          <img :src="settings.image" alt="Badge" />
        </div>

        <div
          class="signup-packages-option__price"
          v-if="price && 'standard' === settings.size"
        >
          <span>{{ price }}</span>
          <span v-if="asterisk">*</span>
        </div>
      </div>
    </button>
    <input :type="type" :name="name" :id="id" v-model="value" />
  </div>
</template>
